module.exports = __webpack_public_path__ + "img/service-3.eaa2cdc7.svg";